export default __webpack_public_path__ + "static/media/andrew_moon.48e2c3f1.png";